import log from 'salvo-lite/log'

class Lightbox {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._options = JSON.parse(elem.getAttribute('data-lightbox'))

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._elem.addEventListener('click', () => {
            this.initLightbox()
        })
    }

    initLightbox () {
        const lightbox = document.createElement('div')
        lightbox.classList.add('lightbox')

        lightbox.addEventListener('click', function (event) {
            if (!event.target.classList.contains('lightbox__inner-container')) {
                document.body.removeChild(this)
            }
        })

        const container = document.createElement('div')
        container.classList.add('lightbox__inner-container')

        lightbox.appendChild(container)

        const closeBtn = document.createElement('span')
        closeBtn.classList.add('lightbox-close')
        closeBtn.innerHTML = '&times;'
        closeBtn.setAttribute('aria-label', 'Close')
        closeBtn.addEventListener('click', function () {
            document.body.removeChild(lightbox)
        })

        lightbox.appendChild(closeBtn)

        const iframe = document.createElement('iframe')
        iframe.setAttribute('src', 'https://www.youtube.com/embed/' + this._options.id)
        iframe.classList.add('responsive-iframe')

        container.appendChild(iframe)

        document.body.appendChild(lightbox)
    }
}

export default Lightbox



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Lightbox.js